import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import TextInput from "../TextInput";
import Cookies from "universal-cookie";

const api_base = process.env.API_URL;
const client_base = process.env.BASE_URL;

export default class UpdatePasswordFromToken extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.userId,
      pw_reset_token: props.match.params.pwResetToken,
      password: "",
      password_confirmation: "",
      error_message: "",
      display_error: false,
    };
  }

  updatePassword = () => {
    let body = {
      id: this.state.id,
      user: {
        pw_reset_token: this.state.pw_reset_token,
        password: this.state.password,
        password_confirmation: this.state.password_confirmation,
      },
    };
    const url = api_base + "users/update_password";
    const reqOptions = {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
    this.api_call(url, reqOptions)
      .then((data) => {
        console.log("data", data);
        console.log("access to history?", this.props.history);
        if (data.success) {
          console.log("should log in");
          //set auth token and redirect to index
          const cookies = new Cookies();
          cookies.set("user_session", data.token.token, { path: "/" });
          this.props.toggleLoggedInState();
          this.props.history.push("/syllabi");
        } else {
          data["display_error"] = true;
          data["error_message"] = JSON.stringify(data.errors);
          this.setState(data);
        }
      })
      .catch((err) => {
        let state = this.state;
        state["display_notice"] = false;
        state["display_error"] = true;
        state["notice_message"] = "Failed to update password.";
        this.setState(state);
      });
  };

  handleTextChange = (key, event) => {
    let state = this.state;
    state[key] = event.target.value;
    this.setState(state);
  };

  api_call = (url, reqOptions) => {
    return new Promise((resolve, reject) => {
      try {
        fetch(url, reqOptions).then((res) => {
          res.json().then((data) => {
            resolve(data);
          });
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  render() {
    let {
      id,
      password,
      password_confirmation,
      error_message,
      display_error,
      can_update,
    } = this.state;

    const page_title = "Change Password";
    const saveBtn =
      password == password_confirmation && password.length >= 8 ? (
        <button
          className="btn btn-primary col-2 mt-4"
          type="submit"
          onClick={this.updatePassword}
        >
          Save
        </button>
      ) : (
        <div className="alert alert-danger">
          Password and Password Confirmation must match, and password must be at
          least 8 characters long...
        </div>
      );

    const notice = display_error ? (
      <div
        role="alert"
        className={
          "card inner-buffer " +
          (display_error ? "alert alert-danger" : "alert alert-success")
        }
      >
        {error_message}
      </div>
    ) : (
      ""
    );

    const pwForm = (
      <div className="card inner-buffer w-50">
        <TextInput
          valText={password}
          inputType="password"
          editMode={true}
          fieldName="password"
          labelText="Password:"
          handleChange={this.handleTextChange}
        />
        <TextInput
          valText={password_confirmation}
          compareVal={password}
          inputType="password"
          editMode={true}
          fieldName="password_confirmation"
          labelText="Password Confirmation:"
          handleChange={this.handleTextChange}
        />
        {saveBtn}
      </div>
    );

    return (
      <div className="container">
        {notice}
        <h1>{page_title}</h1>
        {pwForm}
      </div>
    );
  }
}
